export default __webpack_public_path__ + "static/media/copel-logo.e14f5715.jpg";